import { useMutation } from '@tanstack/react-query';
import useCsrfToken from '../hooks/useCsrfToken';
import { fetchJSON } from '~/api/selfServeFetch';
import { createRequestHeaders } from '~/shared/api/fetchWrapper/index.js';

const postInitiateCheckoutFromEmail = ({
  email,
  csrfToken,
  promoCode = '',
  trialCode,
  billingCadence = 'monthly',
}) => {
  const payload = {
    email,
    billing_cadence: billingCadence,
  };

  if (promoCode && promoCode !== '') {
    payload.promo_code = promoCode;
  }
  if (trialCode && trialCode !== '') {
    payload.trial_code = trialCode;
  }

  return fetchJSON(`/api/selfserve/initiate_checkout_from_email/`, {
    method: 'POST',
    body: payload,
    // due to this being embedded in a frame and the CSRFToken _usually_ being in a cookie with SameSite=Lax, we
    // temporarily stick the csrftoken into the body of the page that renders this react component
    headers: createRequestHeaders({
      getCSRFToken: () => csrfToken,
    }),
  });
};
const useInitiateCheckout = ({ promoCode, trialCode, billingCadence } = {}) => {
  const csrfToken = useCsrfToken();
  const mutation = useMutation({
    mutationFn: ({ email }) =>
      postInitiateCheckoutFromEmail({ email, promoCode, trialCode, billingCadence, csrfToken }),
    onSuccess: ({ data }) => {
      // note, our API nests inside `data`, so this is actually data.data
      // redirect the parent frame based on the returned "redirect_to" url
      // we don't care whether it's a 201 or 200.  The 201 will be direct to stripe, the 200 will be to a login page.
      window.parent.location.href = data.redirect_to;
    },
  });

  return mutation;
};

export default useInitiateCheckout;
